var _style, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOpsmoIconWhite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 193 173",
    style: {
      enableBackground: "new 0 0 193 173"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M119.93,17.73H71.28v0.15C39.5,18.55,13.86,44.61,13.86,76.54c0,32.36,26.32,58.68,58.68,58.68v-24.66 c-18.76,0-34.02-15.26-34.02-34.02c0-18.76,15.26-34.02,34.02-34.02v-0.14h47.39c18.76,0,34.02,15.26,34.02,34.02 s-15.26,34.02-34.02,34.02H91.52v24.66h0.09l0,0.62c0,0,0.54,26.45,26.81,26.45c-0.33-8.89-0.55-18.88-0.69-27.07h2.2 c32.36,0,58.68-26.32,58.68-58.68S152.29,17.73,119.93,17.73z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpsmoIconWhite);
export default __webpack_public_path__ + "static/media/OPSMO_icon_white.ecae33838c7042614090e07f621613cf.svg";
export { ForwardRef as ReactComponent };